import script from "./VerificationNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationNumber.vue?vue&type=script&setup=true&lang=js"

import "./VerificationNumber.vue?vue&type=style&index=0&id=083e4aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083e4aa6"]])

export default __exports__